











import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SponsorOrgSelector from '@superUI/Selectors/SponsorOrgSelector'
import CampaignSelector from '@superUI/Selectors/CampaignSelector'
import EventSelector from '@superUI/Selectors/EventSelector'

settings =
  name: "OfferCreate"
  components: { SuperContainerView, SponsorOrgSelector, CampaignSelector, EventSelector }
  resources:
    newOffer:
        resourceName: 'offer'
        slug: 'offers/new'
  vue:
    data: ->
      selectedSubSponsorId: null
      selectedCampaignId: null
      selectedEventId: null
      topLevelCampaigns: []

    mounted: () ->
      @selectedCampaignId = @$route.params.campaign_id if @$route.params.campaign_id?

    methods:
      onSave: (item) -> @$router.push({ name: 'OfferEditPage', params: { offerId: item.id } })

      hiSave: ->
        @prime.newOffer.campaign_id = @selectedCampaignId
        @prime.newOffer.event_id = @selectedEventId
        @saveItem('prime.newOffer')

      hiBack: ->
        if @selectedEventId
          @selectedEventId = null

      hiSponsorSelected: (selectedSponsor) ->
        @selectedSubSponsorId = selectedSponsor.id

      hiCampaignSelected: (selectedCampaign) ->
        if selectedCampaign
          @selectedCampaignId = selectedCampaign.id
        else
          @selectedSubSponsorId = null
          @selectedCampaignId = null

      hiTopSponsorCampaignSelected: (selectedCampaign, selectedTopSponsorId) ->
        @selectedSubSponsorId = selectedTopSponsorId
        @selectedCampaignId = selectedCampaign.id

      hiEventSelected: (selectedEvent) ->
        if selectedEvent
          @selectedEventId = selectedEvent.id
        else
          @selectedEventId = null
          @selectedCampaignId = null

    watch:
      # selectedCampaignId: (campaignId) ->
        # if campaignId
        #   @fetch('newOffer', { campaign_id: campaignId })

      selectedEventId: (eventId) ->
        if eventId
          @hiSave()

export default VueOptions.vue settings
